module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "switch-map-btn"
  }, [_c('div', {
    staticClass: "top-j"
  }, [_c('span', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.path))])]), _vm._v(" "), _c('a', {
    staticClass: "btn-content",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.change
    }
  }, [_c('i', {
    staticClass: "iconfont icon-you"
  }), _vm._v("\n    " + _vm._s(_vm.isMap ? '切换到表格' : '切换到地图') + "\n  ")]), _vm._v(" "), _c('div', {
    staticClass: "bottom-j"
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-01e4079d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components_bit/SwitchMapBtn.vue
// module id = 769
// module chunks = 1